var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.5H6",
    stroke: "#0986E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.5H9",
    stroke: "#0986E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.5H21",
    stroke: "#0986E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5H21",
    stroke: "#0986E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.5C6 6.56812 6 6.10218 6.15224 5.73463C6.35523 5.24458 6.74458 4.85523 7.23463 4.65224C7.60218 4.5 8.06812 4.5 9 4.5C9.93188 4.5 10.3978 4.5 10.7654 4.65224C11.2554 4.85523 11.6448 5.24458 11.8478 5.73463C12 6.10218 12 6.56812 12 7.5C12 8.43188 12 8.89782 11.8478 9.26537C11.6448 9.75542 11.2554 10.1448 10.7654 10.3478C10.3978 10.5 9.93188 10.5 9 10.5C8.06812 10.5 7.60218 10.5 7.23463 10.3478C6.74458 10.1448 6.35523 9.75542 6.15224 9.26537C6 8.89782 6 8.43188 6 7.5Z",
    stroke: "#0986E6",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5C12 16.5681 12 16.1022 12.1522 15.7346C12.3552 15.2446 12.7446 14.8552 13.2346 14.6522C13.6022 14.5 14.0681 14.5 15 14.5C15.9319 14.5 16.3978 14.5 16.7654 14.6522C17.2554 14.8552 17.6448 15.2446 17.8478 15.7346C18 16.1022 18 16.5681 18 17.5C18 18.4319 18 18.8978 17.8478 19.2654C17.6448 19.7554 17.2554 20.1448 16.7654 20.3478C16.3978 20.5 15.9319 20.5 15 20.5C14.0681 20.5 13.6022 20.5 13.2346 20.3478C12.7446 20.1448 12.3552 19.7554 12.1522 19.2654C12 18.8978 12 18.4319 12 17.5Z",
    stroke: "#0986E6",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.3a30eb1dccbe480d7bd1591248db8ab3.svg";
export { ForwardRef as ReactComponent };